import { Image, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { validateStatus } from "../../pages/FinalUserValidateEmail"
import AwayterConnectImg from '../../utils/resources/awayter_connect_light_cropped.png'
import './ValidateEmail.scss'

const ValidateEmail = (props: { status: validateStatus }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <div className='validateEmail'>
            <div className='validate'>
                <div className='text-center containervalidateEmail p-5'>
                    <Image src={AwayterConnectImg} width={500} className='img-fluid mb-2' />
                    {props.status === validateStatus.Validating && <div className="text-center pt-5"><Spinner animation="border" style={{ color: 'var(--IDGreen)' }} /></div>}
                    {props.status === validateStatus.ComertialValidating &&
                        <div className="d-flex flex-column text-start pt-5">
                            <h3 className="text-center"> Your Account is <strong>NOT READY</strong> yet!</h3>
                            <span className="text-center my-2"> You will recieve an email once your account is ready</span>
                            <div className="py-2 mt-2 d-flex align-items-start" style={{ fontSize: '20px', backgroundColor: 'rgba(3, 255, 3, 0.5)' }}>
                                <i className="bi bi-check-circle ms-2"></i>
                                <div className="ms-2 flex-grow-1">Email validated succesfully</div>
                            </div>
                            <div className="py-2 mt-2 d-flex align-items-start" style={{ fontSize: '20px', backgroundColor: 'rgba(255, 123, 0, 0.5)' }}>
                                <i className="bi bi-clock ms-2"></i>
                                <div className="ms-2 flex-grow-1">Waiting for Awayter team approval</div>
                            </div>
                        </div>
                    }
                    {/* <button onClick={() => navigate('/login')} className='btn-Custom btn-IDGreen mt-4'>{t('Back to login screen')}</button> */}
                    {props.status === validateStatus.OK &&
                        <div className="d-flex flex-column pt-5">
                            <span>Email validated correctly</span>
                        </div>
                    }
                    {props.status === validateStatus.Error &&
                        <div className="d-flex flex-column pt-5">
                            <span>Error Validation Email</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default ValidateEmail